module.exports = (__webpack_require__(2))(38);


//////////////////
// WEBPACK FOOTER
// delegated ./src/pluginUtils.js from dll-reference girder_plugin_slicer_cli_web
// module id = 63
// module chunks = 0